import React from 'react';
import HomepageCategoriesRedesign from '../homepage_categories';
import { getItem } from '@reverbdotcom/commons/src/local_storage_utils';
import HomepageSearchRecommendationsContent from '../homepage_search_recommendations';
import { buildRecentSearches } from '@reverbdotcom/commons/src/components/site_search/reverb_site_search_suggestions';
import AppCallout from '../app_callout';
import BasedOnRecentlyViewed from '../based_on_recently_viewed';
import { MostWatchedListingsCollection } from '../most_watched_listings';
import { JustListedForYouRow } from '../just_listed_for_you';

export function Categories() {
  return <HomepageCategoriesRedesign />;
}

export function HomepageSearchRecommendations() {
  const recentSearches = buildRecentSearches(getItem('RECENT_SEARCHES') || [])?.suggestions[0]?.results || [];
  return <HomepageSearchRecommendationsContent recentSearches={recentSearches} />;
}

export function MostWatchedRow() {
  return <MostWatchedListingsCollection />;
}

export function ReverbAppCallout() {
  return <AppCallout />;
}

export function JustListed() {
  return (
    <JustListedForYouRow
      indentedMosaic={false}
      maxCount={6}
    />
  );
}

export function BasedOnYourRecentlyViewed() {
  return <BasedOnRecentlyViewed />;
}
